// Pure helpers for the editor's pan/zoom - kept separate from Page.js so the
// zoom-clamping and fit-to-screen maths can be reasoned about (and unit
// tested) without a real fabric.Canvas instance.

export const MIN_ZOOM = 0.25;
export const MAX_ZOOM = 4;

export const clampZoom = (zoom) => Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, zoom));

/**
 * Zoom level + pan offset that centres a `contentWidth`x`contentHeight`
 * background image within a `viewportWidth`x`viewportHeight` area, per the
 * "Fit page to screen" control.
 */
export const fitTransform = (contentWidth, contentHeight, viewportWidth, viewportHeight, padding = 0.9) => {
    if (!contentWidth || !contentHeight || !viewportWidth || !viewportHeight) {
        return {zoom: 1, panX: 0, panY: 0};
    }
    const zoom = clampZoom(Math.min(viewportWidth / contentWidth, viewportHeight / contentHeight) * padding);
    const panX = (viewportWidth - contentWidth * zoom) / 2;
    const panY = (viewportHeight - contentHeight * zoom) / 2;
    return {zoom, panX, panY};
};
